let globalHoverDiv = null;
let globalHoverImg = null;

function createHoverElements() {
    if (!globalHoverDiv) {
        globalHoverDiv = document.createElement('div');
        globalHoverDiv.style.position = 'absolute';
        // DraggableDialog 从 10000 起，需高于弹窗才能看见悬停放大图
        globalHoverDiv.style.zIndex = '99998';
        globalHoverDiv.style.border = '1px solid #ccc';
        globalHoverDiv.style.pointerEvents = 'none';
        globalHoverDiv.style.transition = 'opacity 0.2s ease';
        globalHoverDiv.style.backgroundColor = '#fff';
        globalHoverDiv.style.display = 'flex';
        globalHoverDiv.style.alignItems = 'center';
        globalHoverDiv.style.justifyContent = 'center';
        globalHoverDiv.style.opacity = '0';

        globalHoverImg = document.createElement('img');
        globalHoverDiv.appendChild(globalHoverImg);

        document.body.appendChild(globalHoverDiv);
    }
}

function hideHoverImg() {
    if (globalHoverDiv) {
        globalHoverDiv.style.opacity = '0';
        globalHoverDiv.style.top = '-9999px';
        globalHoverDiv.style.left = '-9999px';
    }
}

function withCacheBust(url) {
    if (!url) return url;
    const bare = String(url).split('#')[0];
    const sep = bare.includes('?') ? '&' : '?';
    return `${bare}${sep}t=${Date.now()}`;
}

export default {
    bind(el, binding) {
        el.__hoverDivOptions__ = binding.value || {};

        let timer = null;
        let clickedFlag = false;

        const showImg = () => {
            const {
                img,
                timer: delay = 0,
                maxWidth = 500,
                fixedHeight,
                maxHeight,
                dragging = false,
            } = el.__hoverDivOptions__;
            const previewHeight = fixedHeight ?? maxHeight ?? 700;

            if (clickedFlag || dragging || !img) return;

            createHoverElements(); // 确保 DOM 存在

            // 加时间戳避免命中错误的 1x1 缓存
            globalHoverImg.src = withCacheBust(img);
            globalHoverImg.style.maxWidth = `${maxWidth - 20}px`;
            globalHoverImg.style.maxHeight = `${previewHeight - 20}px`;

            globalHoverDiv.style.width = `${maxWidth}px`;
            globalHoverDiv.style.height = `${previewHeight}px`;

            // 定位逻辑
            const rect = el.getBoundingClientRect();
            const spacing = 10;

            const spaceRight = window.innerWidth - rect.right;
            let left;
            if (spaceRight >= maxWidth + spacing) {
                left = rect.right + spacing + window.scrollX;
            } else {
                left = rect.left - maxWidth - spacing + window.scrollX;
                if (left < 0) left = 0;
            }

            let top = rect.top + window.scrollY;
            const imgBottom = top + previewHeight + 10;
            const viewportBottom = window.scrollY + window.innerHeight;
            if (imgBottom > viewportBottom) {
                top -= (imgBottom - viewportBottom);
                if (top < 0) top = 0;
            }

            globalHoverDiv.style.left = `${left}px`;
            globalHoverDiv.style.top = `${top}px`;

            requestAnimationFrame(() => {
                globalHoverDiv.style.opacity = '1';
            });
        };

        const onMouseEnter = () => {
            clickedFlag = false;
            clearTimeout(timer);
            timer = setTimeout(showImg, el.__hoverDivOptions__.timer || 500);
        };

        const onMouseLeave = () => {
            clearTimeout(timer);
            hideHoverImg();
        };

        const onClick = () => {
            clickedFlag = true;
            hideHoverImg();
        };

        el.__hoverDivCleanup__ = () => {
            clearTimeout(timer);
            hideHoverImg();
            el.removeEventListener('mouseenter', onMouseEnter);
            el.removeEventListener('mouseleave', onMouseLeave);
            el.removeEventListener('click', onClick);
        };

        el.addEventListener('mouseenter', onMouseEnter);
        el.addEventListener('mouseleave', onMouseLeave);
        el.addEventListener('click', onClick);
    },

    update(el, binding) {
        el.__hoverDivOptions__ = binding.value || {};
    },

    unbind(el) {
        if (el.__hoverDivCleanup__) {
            el.__hoverDivCleanup__();
        }
        delete el.__hoverDivOptions__;
        delete el.__hoverDivCleanup__;
    }
};
